import { Body, Tooltip } from '@panwds/react-ui'
import { HUMAN_READABLE_DEVICE_LICENSE_TYPE } from '../../../../constants/LabelConstants'

const NewDeviceAssetTypeRenderer = ({ row, value }) => {
  const { original: { disabled = false, reason } } = row
  if (disabled) {
    return <Tooltip label={reason}>
      <div className='tw-h-full tw-truncate'>
        <Body size="lg" addClassName='tw-truncate tw-text-disabled'>{HUMAN_READABLE_DEVICE_LICENSE_TYPE[value]}</Body>
      </div>
    </Tooltip>
  }
  return <Body size="lg" addClassName='tw-truncate'>{HUMAN_READABLE_DEVICE_LICENSE_TYPE[value]}</Body>
}

NewDeviceAssetTypeRenderer.propTypes = {}
export default NewDeviceAssetTypeRenderer
